<template src="./html/Edit.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	export default {
		props: ['user', 'isAuth', 'resource'],
		data () {
			return {
				modal: {
					selector: 'place-modal-edit-' + new Date().getTime()
				},
				place: {
					formatted_address: null,
					name: null,
					google_place_id: null,
					url: null,
					country: null,
					country_short_name: null,
					postal_code: null,
					administrative_area_level_1: null,
					administrative_area_level_2: null,
					locality: null,
					route: null,
					street_number: null,
					sublocality_level_1: null,
					sublocality_level_2: null,
					lat: null,
					lng: null,
				},
				autocomplete: null,
			}
		},
		methods: {
			open(place) {
				this.load(place)
				this.initAutocomplete()
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close() {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			load(place) {
				if(place) {
					this.place.id = place.id
					this.place.formatted_address = place.formatted_address
					this.place.name = place.name
					this.place.google_place_id = place.google_place_id
					this.place.url = place.url
					this.place.country = place.country
					this.place.country_short_name = place.country_short_name
					this.place.postal_code = place.postal_code
					this.place.administrative_area_level_1 = place.administrative_area_level_1
					this.place.administrative_area_level_2 = place.administrative_area_level_2
					this.place.locality = place.locality
					this.place.route = place.route
					this.place.street_number = place.street_number
					this.place.sublocality_level_1 = place.sublocality_level_1
					this.place.sublocality_level_2 = place.sublocality_level_2
					this.place.lat = place.lat
					this.place.lng = place.lng
				}
			},
			initAutocomplete() {
				var that = this
				this.autocomplete = new google.maps.places.Autocomplete(
					(that.$refs.inputAutocompleteEdit),
					{types: ['geocode']}
				);
				this.autocomplete.addListener('place_changed', function(event) {
					var place = that.autocomplete.getPlace();
					that.loadPlace(place)
				});
			},
			loadPlace(place) {
				this.clearData()
				
				var that = this
				if(place) {
					this.place.formatted_address = place.formatted_address
					this.place.name = place.name
					this.place.google_place_id = place.place_id
					this.place.url = place.url

					this.place.lat = place.geometry.location.lat()
					this.place.lng = place.geometry.location.lng()

					var address_components = []
					if(place.address_components) {
						place.address_components.forEach(function(element) {
							var type = element.types[0]
							var component = {
								type: type,
								value: element.long_name
							}
							address_components.push(component)
							if(type == 'country') {
								var component = {
									type: 'country_short_name',
									value: element.short_name
								}
								address_components.push(component)
							}
						})
					}
					address_components.forEach(function(element) {
						if(that.place[element.type] !== 'undefined') {
							that.place[element.type] = element.value
						}
					})
				}
			},
			clearData() {
				for(var value in this.place) {
					if(value != 'id') {
						this.place[value] = null
					}
				}
			},
			update() {
				var loading = Ladda.create(this.$refs.btnUpdate)
				loading.start()

				this.$http.post(this.resource + '/places/' + this.place.id, this.place)
				.then(response => {
					loading.stop()
					this.$emit('reload')
					this.close()
					swal({
						title: response.body.title,
						text: response.body.text,
						type: response.body.type,
					})
				}).catch(function(response) {
					loading.stop()
					this.$emit('reload')
					swal({
						title: response.statusText,
						text: response.body,
						type: "warning",
					})
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/places/views/Edit.vue